module.exports = __webpack_public_path__ + "img/banner-30-off.404075be.png";